import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { FaStar, FaShoppingCart, FaHeart, FaUser, FaHome, FaPhone, FaEnvelope } from 'react-icons/fa';
import { useCart } from '../context/CartContext';

const productsData = [
  {
    id: 1,
    name: 'Pistazien-Trüffelbox',
    price: 29.90,
    rating: 5,
    shortDesc: 'Feine Trüffel mit Pistazienherz',
    description: 'Unsere Pistazien-Trüffel sind eine Hommage an die italienische Confiserie-Kunst. Jede Trüffel wird von Hand gefertigt und mit feinster Pistaziencreme gefüllt. Die dunkle Kakaoumhüllung harmoniert perfekt mit dem nussigen Aroma. Die Box enthält zwölf handverlesene Trüffel, verziert mit gehackten Pistazien. Perfekt als Geschenk oder für den eigenen Genuss. Die Trüffel werden täglich frisch in unserer Manufaktur in Ettlingen hergestellt.',
    image: '/images/1.jpg',
    isNew: true,
    detailedInfo: 'Die Pistazien-Trüffel von Novurem werden ausschließlich mit Pistazien aus Sizilien hergestellt. Unsere Chocolatiers verfeinern die Trüffel mit einem Hauch von Meersalz und echter Bourbon-Vanille. Die Herstellung dauert 48 Stunden und erfolgt in kleinen Chargen. Jede Trüffel ist ein Unikat und wird nach traditionellem Rezept gefertigt.'
  },
  {
    id: 2,
    name: 'Vanille-Macarons',
    price: 24.50,
    rating: 4,
    shortDesc: 'Luftige Macarons mit Bourbonvanille',
    description: 'Unsere Vanille-Macarons sind ein Klassiker der französischen Patisserie. Die zarten Mandelmakronen werden mit einer cremigen Bourbonvanille-Füllung kombiniert. Die Textur ist außen knusprig und innen herrlich weich. Jede Box enthält zehn handgefertigte Macarons. Die Vanille stammt aus Madagaskar und verleiht den Macarons ein unvergleichliches Aroma.',
    image: '/images/2.jpg',
    isNew: false,
    detailedInfo: 'Für unsere Vanille-Macarons verwenden wir ausschließlich echtes Bourbonvanille-Mark aus Madagaskar. Die Mandeln werden täglich frisch gemahlen und mit Bio-Eiweiß zu einer perfekten Konsistenz verarbeitet. Die Macarons werden 24 Stunden im Kühlhaus gereift, bevor sie ihre perfekte Textur erreichen.'
  },
  {
    id: 3,
    name: 'Schwarzwälder Kirschtorte',
    price: 45.00,
    rating: 5,
    shortDesc: 'Klassiker mit dunklen Kirschen',
    description: 'Unsere Schwarzwälder Kirschtorte ist ein Meisterwerk der Konditorkunst. Dunkle Schokolade, frische Sahne und herb-süße Kirschen bilden eine perfekte Einheit. Die Torte wird in unserer Manufaktur nach überliefertem Familienrezept hergestellt. Der Feinschliff: ein Hauch von Kirschwasser und echte Bourbonvanille. Die Torte reicht für 12 Personen.',
    image: '/images/3.jpg',
    isNew: false,
    detailedInfo: 'Die Schwarzwälder Kirschtorte von Novurem wird mit Kirschen aus dem Schwarzwald und echter Kakaomasse aus Ecuador hergestellt. Die Tortenböden werden über Nacht gereift und mit einer speziellen Kirsch-Sahne-Creme geschichtet. Jede Torte wird von Hand dekoriert und mit Schokoladenraspeln verfeinert.'
  },
  {
    id: 4,
    name: 'Kirsch-Pralinen-Auswahl',
    price: 34.90,
    rating: 4,
    shortDesc: 'Zwölf Pralinen mit Cherry-Brandy',
    description: 'Entdecken Sie unsere erlesene Kirsch-Pralinen-Auswahl. Zwölf handgefertigte Pralinen mit Kirschbrand und kandierten Kirschstückchen. Die Kombination aus dunkler Schokolade und fruchtigem Kirschherz ist ein Erlebnis. Jede Praline wird sorgfältig in unserer Werkstatt in Ettlingen gefertigt. Ideal als Geschenk oder für besondere Anlässe.',
    image: '/images/4.jpg',
    isNew: false,
    detailedInfo: 'Für die Kirsch-Pralinen verwenden wir nur Kirschen aus regionalem Anbau. Diese werden 48 Stunden in edlem Kirschbrand eingelegt und anschließend in zartschmelzende Kakaomasse getunkt. Unsere Chocolatiers überwachen jeden Schritt der Herstellung persönlich.'
  },
  {
    id: 5,
    name: 'Pistazien-Croissant',
    price: 18.90,
    rating: 5,
    shortDesc: 'Butter-Croissant mit Pistaziencreme',
    description: 'Unser Pistazien-Croissant ist die perfekte Verbindung von buttrigem Blätterteig und cremiger Pistazienfüllung. Jeden Morgen wird das Croissant frisch gebacken und mit hausgemachter Pistaziencreme gefüllt. Der köstliche Crunch von karamellisierten Pistazien rundet den Geschmack ab. Die Box enthält vier Croissants.',
    image: '/images/5.jpg',
    isNew: true,
    detailedInfo: 'Die Pistazien-Croissants werden nach traditionellem französischem Rezept zubereitet. Der Teig wird 72 Stunden lang geschichtet und mürbe gemacht. Unsere Pistaziencreme wird täglich frisch aus Sizilianischen Pistazien zubereitet und mit einem Hauch von Orangenblüte veredelt.'
  }
];

export default function ProductDetail() {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const navigate = useNavigate();
  const { addToCart } = useCart();

  useEffect(() => {
    const foundProduct = productsData.find((p) => p.id === parseInt(id));
    if (foundProduct) {
      setProduct(foundProduct);
    }
  }, [id]);

  if (!product) {
    return (
      <div className="container" style={{ textAlign: 'center', padding: '80px 20px' }}>
        <h2 style={{ color: '#7b1e3a', fontSize: '32px' }}>Produkt nicht gefunden</h2>
        <p>Das gesuchte Produkt ist leider nicht verfügbar.</p>
        <div style={{ marginTop: '20px' }}>
          <Link to="/" className="btn btn-primary"><FaHome /> Zur Startseite</Link>
        </div>
      </div>
    );
  }

  const handleBuyNow = () => {
    addToCart(product);
    navigate('/checkout');
  };

  const renderStars = (rating) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(
        <FaStar key={i} color={i <= rating ? '#f7d9a8' : '#ddd'} />
      );
    }
    return stars;
  };

  return (
    <div>
      <Helmet>
        <title>{product.name} - Novurem Patisserie</title>
        <meta name="description" content={product.shortDesc} />
        <meta property="og:title" content={product.name} />
        <meta property="og:description" content={product.shortDesc} />
        <meta property="og:image" content={`https://novurem.com${product.image}`} />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Product",
            "name": product.name,
            "description": product.description,
            "image": `https://novurem.com${product.image}`,
            "offers": {
              "@type": "Offer",
              "priceCurrency": "EUR",
              "price": product.price,
              "availability": "https://schema.org/InStock"
            }
          })}
        </script>
      </Helmet>

      <section className="detail-section">
        <div className="container">
          <div className="detail-grid">
            <img src={product.image} alt={product.name} className="detail-img" />
            <div className="detail-info">
              <div className="rating">{renderStars(product.rating)}</div>
              <h2>{product.name}</h2>
              <div className="detail-price">{product.price.toFixed(2)} €</div>
              <p className="detail-desc">{product.description}</p>
              <h3 style={{ color: '#7b1e3a', fontSize: '18px', marginTop: '20px' }}>Herstellungsdetails</h3>
              <p className="detail-desc">{product.detailedInfo}</p>
              <div className="detail-actions">
                <button onClick={() => addToCart(product)} className="btn btn-primary">
                  <FaShoppingCart /> In den Warenkorb
                </button>
                <button onClick={handleBuyNow} className="btn btn-secondary">
                  <FaHeart /> Jetzt kaufen
                </button>
              </div>
              <p style={{ marginTop: '20px', fontSize: '14px', color: '#666' }}>
                Lieferzeit: 2-3 Werktage deutschlandweit
              </p>
              <p style={{ fontSize: '14px', color: '#666' }}>
                Versandkostenfrei ab 50 € Bestellwert
              </p>
              <div style={{ marginTop: '20px' }}>
                <Link to="/" className="btn btn-ghost btn-sm"><FaHome /> Zurück zur Startseite</Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}